import { jsx as _jsx } from "react/jsx-runtime";
const ProductTileContainer = ({ url, onProductClick, className, children, }) => {
    return url ? (_jsx("a", { href: url, onClick: onProductClick, className: className, children: children })) : (_jsx("div", { role: "presentation", onClick: onProductClick, onKeyPress: onProductClick, className: className, children: children }));
};
export { ProductTileContainer };
